/**
 *  Summary: Load by async way and start the code to manage the
 *           basic Forms on the Full Image Viewer.
 */
(function fullImageViewerBasicFormsHandlerLoader(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  const previousFullImageViewerBasicFormsHandlerLoader =
    global.NewHomeSource.FullImageViewer.FullImageViewerBasicFormsHandlerLoader;

  /**
   * @constructs NewHomeSource.FullImageViewer.FullImageViewerBasicFormsHandlerLoader
   */
  function FullImageViewerBasicFormsHandlerLoader() { }

  function initBasicFormHandler(containerElement, querySelectorTemplate) {
    if (global.NewHomeSource.FullImageViewer.FullImageViewerBasicFormsHandler) {
      containerElement.removeAttribute('hidden');
      global.NewHomeSource.FullImageViewer.FullImageViewerBasicFormsHandler
        .Init(containerElement, querySelectorTemplate);
    }
  }

  /**
   * @public
   * loadBasicForm: Load the basicFormHandler js code by the async way.
   */
  FullImageViewerBasicFormsHandlerLoader.loadBasicForm =
    function loadBasicForm(containerElement, querySelectorTemplate) {
      if (!containerElement || !querySelectorTemplate) {
        return;
      }

      const url = document.getElementById('fullImageViewerBasicFormsHandler');
      if (global.NHS && url) {
        global.NHS.loadJs(url.value, 'fullImageViewerBasicFormsHandler', () => {
          initBasicFormHandler(containerElement, querySelectorTemplate);
        });
      } else {
        require(['fullImageViewerBasicFormsHandler', 'emailDomainValidator'], () => {
          initBasicFormHandler(containerElement, querySelectorTemplate);
          global.NewHomeSource.EmailDomainValidator();
        });
      }
    };

  /**
   * @public
   * noConflict: Returns control of NewHomeSource.FullImageViewerBasicFormsHandlerLoader to the previous script.
   */
  FullImageViewerBasicFormsHandlerLoader.noConflict = function noConflict() {
    global.NewHomeSource.FullImageViewer.FullImageViewerBasicFormsHandlerLoader =
      previousFullImageViewerBasicFormsHandlerLoader;
    return FullImageViewerBasicFormsHandlerLoader;
  };

  global.NewHomeSource.FullImageViewer.FullImageViewerBasicFormsHandlerLoader = FullImageViewerBasicFormsHandlerLoader;
}(window));
